export enum MedicalAttestationTypeEnum {
  MEDICATION = 'MEDICATION',
  HANDICAP = 'HANDICAP'
}

export const MedicalAttestationTypeEnumMapping: Record<MedicalAttestationTypeEnum, string> = {
  [MedicalAttestationTypeEnum.MEDICATION]: 'Médicament',
  [MedicalAttestationTypeEnum.HANDICAP]: 'Handicap'
}
